import styles from './styles.module.scss';

const BypassLink = ({ contentId }) => (
    <div className={styles.bypassLink}>
        <a href={`#${contentId}`} className={styles.button}>
            Skip to Main Content
        </a>
    </div>
);
export default BypassLink;
